import { Link } from 'react-router-dom';
import { categories } from '@/mocks/home';
import SectionHead from './SectionHead';

export default function Categories() {
  return (
    <section id="products" className="bg-background-50">
      <div className="max-w-[1280px] mx-auto px-5 md:px-10 lg:px-12 py-24 md:py-32">
        <SectionHead label="Product Categories" title="COMPONENTS FOR EVERY FLOW." intro="Nine product families for isolation, control, protection and connection, sourced and quoted with the documentation your project needs." />
        <div className="flex flex-wrap justify-center gap-x-5 md:gap-x-6 gap-y-12 mt-14 md:mt-20" data-product-shop>
          {categories.map((c) => (
            <Link key={c.no} to={`/products?category=${encodeURIComponent(c.name)}`} className="reveal group cursor-pointer flex flex-col w-[calc((100%-20px)/2)] md:w-[calc((100%-48px)/3)] lg:w-[calc((100%-96px)/5)]">
              <div className="r-img w-full aspect-square bg-background-100 flex items-center justify-center p-5">
                <img src={c.image} alt={`${c.name} - industrial component supply`} title={`${c.name} - NORTHLINE`} className="max-h-full max-w-full object-contain object-center transition-transform duration-700 group-hover:scale-[1.04]" />
              </div>
              <h3 className="mt-4 t-body font-medium text-foreground-950 group-hover:text-primary-500 transition-colors">{c.name}</h3>
              <p className="mt-1 text-sm text-foreground-600">{c.note}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}